module.exports = __webpack_public_path__ + "static/media/camera.871633ce.png";